/* nc-beeper.js
 * Geo-aware shipping badge for Nunchi Club PDPs.
 *
 * Strategy (in order, first hit wins):
 *   1. window.Shopify.country - set by Shopify Markets when shop has Markets
 *      configured. Free, instant, no network. ISO 3166-1 alpha-2.
 *   2. /cdn-cgi/trace - works if the storefront is Cloudflare-fronted
 *      (nunchiclub.com IS proxied through Shopify's edge which exposes this).
 *      Free, no key, no rate limit.
 *   3. https://ipapi.co/country/ - free 1k req/day, no key. Last resort.
 *
 * Maps:
 *   AU -> "Ships Fast from Australia"
 *   US -> "Ships Fast from California"
 *   GB -> "Ships Fast from the U.K"
 *   *  -> "Ships Fast from USA"  (default, also SSR initial render)
 *
 * If all geo lookups fail or return nothing, the SSR default stays. No
 * layout shift, no spinner, no error UI - the badge is decorative trust
 * signal and graceful degradation matters more than perfect geo accuracy.
 */
(function () {
  'use strict';

  var COUNTRY_TO_TEXT = {
    AU: 'Ships Fast from Australia',
    US: 'Ships Fast from California',
    GB: 'Ships Fast from the U.K',
  };
  var DEFAULT_TEXT = 'Ships Fast from USA';

  function textForCountry(code) {
    if (!code) return DEFAULT_TEXT;
    var key = String(code).toUpperCase().trim();
    return COUNTRY_TO_TEXT[key] || DEFAULT_TEXT;
  }

  function setBadgeText(text) {
    var els = document.querySelectorAll('[data-nc-beeper-text]');
    for (var i = 0; i < els.length; i++) {
      // Only update if different - avoid pointless DOM churn / SR reannouncement.
      if (els[i].textContent !== text) els[i].textContent = text;
    }
  }

  // Shipping block (PDP multicolumn 'Free Shipping' card) - richer geo treatment
  // than the title beeper: pill text + dot color + body copy all swap by country.
  var SHIP_BLOCK = {
    AU: {
      pillText: 'SHIPS FAST FROM AUSTRALIA',
      body: 'We ship from your backyard. Fast, local, no customs headaches. Just your tee, on its way.',
      color: 'green',
      pulse: false,
    },
    US: {
      pillText: 'SHIPS FAST FROM CALIFORNIA',
      body: 'Ships fast from California. Coast to coast, your drop arrives before the hype fades.',
      color: 'green',
      pulse: false,
    },
    GB: {
      pillText: 'SHIPS FAST FROM THE UK',
      body: 'Ships fast from the UK. Straight to your door, no waiting on the other side of the world.',
      color: 'green',
      pulse: false,
    },
    ROW: {
      pillText: 'SHIPS FAST FROM USA',
      body: 'Ships worldwide from the USA. Wherever you are, the culture travels.',
      color: 'red',
      pulse: true,
    },
  };

  function updateShipBlock(code) {
    var blocks = document.querySelectorAll('[data-nc-ship-block]');
    var bodies = document.querySelectorAll('[data-nc-ship-body]');
    if (!blocks.length && !bodies.length) return;
    var key = String(code || '').toUpperCase();
    if (['AU', 'US', 'GB'].indexOf(key) === -1) key = 'ROW';
    var cfg = SHIP_BLOCK[key];
    var state = (cfg.color === 'green') ? 'green' : (cfg.pulse ? 'red-pulse' : 'red');

    // Pill (may live as sibling or child of the block depending on how
    // Shopify's HTML sanitizer reshapes our structure - query both).
    var pills = document.querySelectorAll('[data-nc-ship-pill]');
    for (var i = 0; i < pills.length; i++) {
      pills[i].setAttribute('data-nc-ship-state', state);
    }
    var pillTexts = document.querySelectorAll('[data-nc-ship-pill-text]');
    for (var j = 0; j < pillTexts.length; j++) {
      if (pillTexts[j].textContent !== cfg.pillText) pillTexts[j].textContent = cfg.pillText;
    }
    for (var k = 0; k < bodies.length; k++) {
      if (bodies[k].textContent !== cfg.body) bodies[k].textContent = cfg.body;
    }
  }

  function fromShopify() {
    try {
      if (window.Shopify && window.Shopify.country) {
        return Promise.resolve(String(window.Shopify.country).toUpperCase());
      }
    } catch (_) {}
    return Promise.resolve(null);
  }

  function fromCloudflareTrace() {
    return fetch('/cdn-cgi/trace', { method: 'GET', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text) return null;
        var m = text.match(/^loc=([A-Z]{2})$/m);
        return m ? m[1] : null;
      })
      .catch(function () { return null; });
  }

  function fromIpapi() {
    return fetch('https://ipapi.co/country/', { method: 'GET', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        var code = (text || '').trim().toUpperCase();
        return /^[A-Z]{2}$/.test(code) ? code : null;
      })
      .catch(function () { return null; });
  }

  function resolveCountry() {
    return fromShopify().then(function (c) {
      if (c) return c;
      return fromCloudflareTrace().then(function (c2) {
        if (c2) return c2;
        return fromIpapi();
      });
    });
  }

  function init() {
    var hasBeeper = !!document.querySelector('[data-nc-beeper]');
    var hasShipBlock = !!document.querySelector('[data-nc-ship-block]');
    if (!hasBeeper && !hasShipBlock) return;
    resolveCountry().then(function (code) {
      if (hasBeeper) setBadgeText(textForCountry(code));
      if (hasShipBlock) updateShipBlock(code);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
